import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const midnight = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#FFFFFF',
    pageBackground: '#000000',
    secondaryFont: '#DDD8FF',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.paris.midnight.accent
      ? THEME_DEFAULT_FONTS.paris.midnight.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.paris.midnight.body.value,
    heading: THEME_DEFAULT_FONTS.paris.midnight.headline.value,
  },
  fontWeights: {
    body: 400,
    heading: 600,
  },
  shadows: {
    basic10: '0 0 $64 rgba(228, 232, 247, 0.15)',
  },
});
